import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const AuthContainer = styled.div`
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  background: rgba(18, 34, 64, 0.6);
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 194, 255, 0.2);
`;

const AuthTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  color: #ffffff;
  font-size: 2rem;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #c4cdda;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid rgba(0, 194, 255, 0.3);
  background: rgba(18, 34, 64, 0.4);
  color: #ffffff;
  font-size: 1rem;
  
  &:focus {
    outline: none;
    border-color: #00c2ff;
    box-shadow: 0 0 0 2px rgba(0, 194, 255, 0.2);
  }
`;

const AuthButton = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(90deg, #00c2ff, #64ffda);
  color: #0c162d;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 194, 255, 0.4);
  }
`;

const AuthLink = styled.p`
  text-align: center;
  margin-top: 20px;
  color: #c4cdda;
  
  a {
    color: #64ffda;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  text-align: center;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 8px;
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Simple validation
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }
    
    // In a real app, you would make an API call here to authenticate the user
    // For demo purposes, we'll accept any non-empty email and password
    console.log('Login attempt with:', { email, password });
    
    // Set authentication state
    localStorage.setItem('isAuthenticated', 'true');
    
    // Redirect to dashboard after successful login
    navigate('/dashboard');
  };

  return (
    <AuthContainer>
      <AuthTitle>Login to UPM Traders</AuthTitle>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="email">Email Address</Label>
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
          />
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
        </FormGroup>
        
        <AuthButton type="submit">Login</AuthButton>
      </form>
      
      <AuthLink>
        Don't have an account? <a href="/register">Register here</a>
      </AuthLink>
    </AuthContainer>
  );
};

export default Login;